module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAABHNCSVQICAgIfAhkiAAAAR5JREFUSInVVEt2gzAMHAH3qnMivAmPVbGy6ks2yYlwDxarC+MXh8gPN00XmQ3YSJoR+gDvDjrs+1kIpmgg8EL0PR3PLr/nwToS+djyJR56+YUejk+Zaj269DIdL6QZuNGa5ipTVJoHjmTrzBKS8E77eEfwdfYAvButoSBzCl4KvEZTY5SISOBJ4GuDA0oGh30/r+8+T5ed5qzZhpZ4yfqRwI3WSBBTq67QQZwf7gkis1psDaXGyFFdg2fx8ItunXJDSak2Q9LQrlgDIE5frTrNds2o1aCaoNRdOf69Bu9PsLlNUyFDS9xc47ILLTEFmK11DQBd3Irl9ZsCUBAjS7PSMu2yOWbEmyZxNjS1xNLA5z3/Z/BgHQ/WvSzgK/ADPZaFwFDG6q8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/icon3.png
// module id = crk9
// module chunks = 1